import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { sellersApi, type SellerListItem } from '../lib/api';

export default function SellersList() {
  const [items, setItems] = useState<SellerListItem[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    sellersApi.list()
      .then((r) => setItems(r.sellers))
      .catch((e) => setErr(String(e?.message ?? e)));
  }, []);

  if (err) return <div className="container"><div className="error">{err}</div></div>;
  if (!items) return <div className="container"><p className="muted">Загрузка…</p></div>;

  return (
    <div className="container">
      <div className="page-head">
        <h2>Продавцы</h2>
        <Link to="/sellers/new" className="btn primary">+ Новый продавец</Link>
      </div>

      {items.length === 0 ? (
        <p className="muted">Пока ни одного продавца. Создай первого.</p>
      ) : (
        <table className="grid">
          <thead>
            <tr>
              <th>#</th>
              <th>Логин</th>
              <th>Имя</th>
              <th>Email</th>
              <th>shop_id</th>
              <th>Токен</th>
              <th>Активен</th>
              <th>Быстро</th>
            </tr>
          </thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.id}>
                <td>{s.id}</td>
                <td><Link to={`/sellers/${s.id}`}>{s.login}</Link></td>
                <td>{s.display_name ?? <span className="muted">—</span>}</td>
                <td>{s.contact_email ?? <span className="muted">—</span>}</td>
                <td>{s.flowwow_shop_id ?? <span className="muted">—</span>}</td>
                <td>
                  {s.has_token
                    ? <span className="badge ok">есть</span>
                    : <span className="badge warn">нет</span>}
                </td>
                <td>{s.is_active ? '✓' : '—'}</td>
                <td>
                  <Link to={`/products?seller_id=${s.id}`} className="link-btn" style={{ fontSize: 12 }}>товары</Link>
                  {' · '}
                  <Link to={`/prices?seller_id=${s.id}`} className="link-btn" style={{ fontSize: 12 }}>прайсы</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
